import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaExplorerV2Component } from '../../media-explorer-v2/media-explorer-v2.component';

@Component({
    selector: 'app-sem-file-explorer-dialog',
    templateUrl: './sem-file-explorer-dialog.component.html',
    styleUrls: ['./sem-file-explorer-dialog.component.css'],
    standalone: true,
    imports: [CommonModule, MediaExplorerV2Component],
})
export class SemFileExplorerDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SemFileExplorerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {}

  ngOnInit(): void {}
}
